import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SiteLayout from './SiteLayout';
import { IconArrow, IconCheck, IconDash } from './icons';
import { API_CONFIG } from '../../config/api';

const brl = (v) => Number(v).toLocaleString('pt-BR');

export default function Planos() {
  const [plans, setPlans] = useState(null); // null = carregando
  const [err, setErr] = useState(false);
  const [period, setPeriod] = useState('mensal');

  useEffect(() => {
    let alive = true;
    fetch(`${API_CONFIG.BASE_URL}/admin/plans`)
      .then((r) => r.json())
      .then((j) => {
        if (!alive) return;
        const list = (j?.data || []).slice().sort((a, b) => (a.monthlyPrice || 0) - (b.monthlyPrice || 0));
        setPlans(list);
      })
      .catch(() => alive && setErr(true));
    return () => { alive = false; };
  }, []);

  return (
    <SiteLayout>
      <section className="cc-phero">
        <div className="cc-hero-orb o1" />
        <div className="cc-wrap cc-hero-copy">
          <span className="cc-eyebrow">planos</span>
          <h1 className="cc-h1">Escolha o plano da sua <span className="cc-serif">evolução</span>.</h1>
          <p className="cc-hero-sub">
            Comece de graça e evolua quando quiser. Todos os planos com prática de verdade e o
            Pensamento de Engenheiro no centro — sem burocracia.
          </p>
          <div className="cc-bill" role="group" aria-label="Periodicidade">
            <button className={period === 'mensal' ? 'on' : ''} onClick={() => setPeriod('mensal')}>Mensal</button>
            <button className={period === 'trimestral' ? 'on' : ''} onClick={() => setPeriod('trimestral')}>Trimestral</button>
          </div>
        </div>
      </section>

      <section className="cc-section" style={{ paddingTop: 0 }}>
        <div className="cc-wrap">
          {plans === null && !err && <p className="cc-note">Carregando planos…</p>}
          {err && <p className="cc-note">Não foi possível carregar os planos agora. Tente novamente em instantes.</p>}
          {plans && plans.length === 0 && <p className="cc-note">Nenhum plano disponível no momento.</p>}

          {plans && plans.length > 0 && (
            <div className="cc-plans">
              {plans.map((p) => {
                const isFree = !p.monthlyPrice;
                const price = period === 'trimestral' ? (p.quarterlyPrice ?? p.monthlyPrice) : p.monthlyPrice;
                const alt = isFree
                  ? 'para sempre'
                  : period === 'mensal'
                    ? (p.quarterlyPrice ? `ou R$ ${brl(p.quarterlyPrice)}/mês no trimestral` : '')
                    : 'cobrado a cada 3 meses';
                return (
                  <div
                    className={`cc-plan${p.isRecommended ? ' is-rec' : ''}`}
                    key={p.id}
                    style={{ '--plan-accent': p.color || 'var(--cc-coffee)' }}
                  >
                    {p.isRecommended && <span className="cc-plan-badge">recomendado</span>}
                    <div className="cc-plan-name">{p.name}</div>

                    <div className="cc-plan-price">
                      {isFree ? (
                        <span className="cc-plan-val">Grátis</span>
                      ) : (
                        <>
                          <span className="cc-plan-cur">R$</span>
                          <span className="cc-plan-val">{brl(price)}</span>
                          <span className="cc-plan-per">/mês</span>
                        </>
                      )}
                    </div>
                    <div className="cc-plan-alt">{alt}</div>

                    <ul className="cc-plan-feats">
                      {(p.features || []).map((f, i) => (
                        <li className={`cc-plan-feat${f.included ? '' : ' off'}`} key={i}>
                          <span className="ic">{f.included ? <IconCheck /> : <IconDash />}</span>
                          <span>{f.text}</span>
                        </li>
                      ))}
                    </ul>

                    <Link className={`cc-btn ${p.isRecommended ? 'cc-btn-primary' : 'cc-btn-ghost'}`} to="/treinamentos/cadastro">
                      {isFree ? 'Começar grátis' : 'Assinar'} <IconArrow />
                    </Link>
                  </div>
                );
              })}
            </div>
          )}

          <p className="cc-note" style={{ paddingBottom: 0 }}>
            Ainda com dúvida? <Link to="/treinamentos/cadastro" style={{ color: 'var(--cc-gold)' }}>Crie sua conta grátis</Link> e explore antes de assinar.
          </p>
        </div>
      </section>
    </SiteLayout>
  );
}
